module.exports = __webpack_public_path__ + "img/product-event-1-mobile.1287e3d5.jpg";